import React from "react";
import { LOGO } from "../utility/constains";
import { motion } from "framer-motion";

const Header = () => {
  return (
    <motion.header
      className="w-full px-4 md:px-8 py-2 bg-white flex justify-between items-center border-b border-gray-300 fixed top-0 shadow-xl z-50 "
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ type: "spring", stiffness: 80, duration: 0.8 }}
    >
      <motion.img
        className="w-48 md:w-60 lg:w-72 rounded-3xl ml-4 md:ml-16"
        src={LOGO}
        alt="LOGO"
        whileHover={{ scale: 1.1 }}
        transition={{ type: "spring", stiffness: 150 }}
      />
    </motion.header>
  );
};

export default Header;
